import { createPaginator } from "@smithy/core";
import { ChimeSDKMessagingClient } from "../ChimeSDKMessagingClient";
import { ListSubChannelsCommand, } from "../commands/ListSubChannelsCommand";
export const paginateListSubChannels = createPaginator(ChimeSDKMessagingClient, ListSubChannelsCommand, "NextToken", "NextToken", "MaxResults");
